const whBaseData = {
  assessItem: 'AssessItem',
  category: 'Category',
  categoryType: 'CategoryType',
  subCategory: 'SubCategory',
  versionNo: 'VersionNo',
  isEffective: 'IsEffective',
  briefDesc: 'BriefDesc',
  assessContent: 'AssessContent',
  citationBasis: 'CitationBasis',
  score: 'Score',
  breachExample: 'BreachExample',
  msg: {}
};
export default whBaseData;



// WEBPACK FOOTER //
// ./src/page/assess/whBaseData/lang/whBaseData.en.js